import React, { PropTypes } from 'react';
import AlertMessage from '../AlertMessage';

const FormErrorNotification = React.createClass({
    propTypes: {
        error: PropTypes.string,
        onDismiss: PropTypes.func
    },
    render: function() {
        const { error, onDismiss } = this.props;
        
        return <div>
            {error && <AlertMessage type="fail" onDismiss={onDismiss}>
                {error}
            </AlertMessage>}
        </div>;
    }
});

export default FormErrorNotification;


// WEBPACK FOOTER //
// ./src/components/common/FormErrorNotification/index.jsx